<template>
  <div>
    <AppBuffetReceipt
      v-if="receipt_size === 'Buffet'"
      :item="item"
      :show_logo="show_logo"
      :branch="branch"
      :show_phone_number="show_phone_number"
      :show_payment_method="show_payment_method"
      :footer_text="footer_text"
    />
    <AppReceiptA4
      v-else-if="receipt_size === 'A4-01' || receipt_size === 'A4'"
      :item="item"
      :show_logo="show_logo"
      :branch="branch"
      :show_phone_number="show_phone_number"
      :customer_point="customer_point"
      :customer_phone="customer_phone"
      :customer_address="customer_address"
      :customer_logistics="customer_logistics"
      :thb_currency="thb_currency"
      :usd_currency="usd_currency"
      :tax_include="tax_include"
      :show_qr="show_qr"
      :footer_text="footer_text"
      :show_payment_method="show_payment_method"
      :show_email="show_email"
      :show_bank_account="show_bank_account"
      :show_amount_letter="show_amount_letter"
    />
    <AppReceiptA4_02
      v-else-if="receipt_size === 'A4-02'"
      :item="item"
      :show_logo="show_logo"
      :branch="branch"
      :show_phone_number="show_phone_number"
      :customer_point="customer_point"
      :customer_phone="customer_phone"
      :customer_address="customer_address"
      :customer_logistics="customer_logistics"
      :thb_currency="thb_currency"
      :usd_currency="usd_currency"
      :tax_include="tax_include"
      :show_qr="show_qr"
      :footer_text="footer_text"
      :show_payment_method="show_payment_method"
      :show_email="show_email"
      :show_bank_account="show_bank_account"
      :show_amount_letter="show_amount_letter"
    />
    <AppReceipt
      v-else
      :item="item"
      :show_logo="show_logo"
      :branch="branch"
      :show_phone_number="show_phone_number"
      :customer_point="customer_point"
      :customer_phone="customer_phone"
      :customer_address="customer_address"
      :customer_logistics="customer_logistics"
      :thb_currency="thb_currency"
      :usd_currency="usd_currency"
      :tax_include="tax_include"
      :barcode="barcode"
      :show_qr="show_qr"
      :footer_text="footer_text"
      :receipt_size="receipt_size"
      :show_payment_method="show_payment_method"
      :receipt_show_stamp_card="receipt_show_stamp_card"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppReceipt from "@/components/settings/bills/AppReceipt.vue";
import AppReceiptA4 from "@/components/settings/bills/AppReceiptA4.vue";
import AppReceiptA4_02 from "@/components/settings/bills/AppReceiptA4_02.vue";
import AppBuffetReceipt from "@/components/settings/bills/AppBuffetReceipt.vue";

export default {
  components: {
    AppReceipt,
    AppReceiptA4,
    AppReceiptA4_02,
    AppBuffetReceipt,
  },
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    show_logo() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.show_logo);
      }
    },
    branch() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.branch);
      }
    },
    customer_point() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.customer_point);
      }
    },
    customer_phone() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.customer_phone);
      }
    },
    customer_address() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.customer_address);
      }
    },
    customer_logistics() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.customer_logistics);
      }
    },
    thb_currency() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.thb_currency);
      }
    },
    usd_currency() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.usd_currency);
      }
    },
    tax_include() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.tax_include);
      }
    },
    barcode() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.barcode);
      }
    },
    show_qr() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.show_qr);
      }
    },
    footer_text() {
      if (this.user && this.user.stores) {
        return this.user.stores.footer_text;
      }
    },
    receipt_size() {
      if (this.user && this.user.branch_id) {
        const size = this.user.branch_id.receipt_size;
        // Handle backward compatibility: convert "A4" to "A4-01"
        return size === "A4" ? "A4-01" : size;
      }
      return "80mm";
    },
    show_payment_method() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.show_payment_method);
      }
    },
    show_phone_number() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.show_phone_number);
      }
    },
    show_email() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.show_email);
      }
    },
    show_bank_account() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.show_bank_account);
      }
    },
    show_amount_letter() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.show_amount_letter);
      }
    },
    receipt_show_stamp_card() {
      if (this.user && this.user.stores) {
        return this._convertValue(this.user.stores.receipt_show_stamp_card);
      }
    },
  },
  methods: {
    _convertValue(value) {
      return value ? true : false;
    },
  },
};
</script>
